import { Chip } from '@material-ui/core'

export const RoleBadge = ({ role }) => {
  if (!role) return null
  let label = role
  let backgroundColor = '#5f6368'
  switch (role) {
    case 'CS Member':
      label = 'CS'
      backgroundColor = 'orange'
      break
    case 'Owner':
      label = 'Propriétaire'
      backgroundColor = '#5f6368'
      break
    case 'Delegator':
      label = 'Mandataire'
      backgroundColor = 'blue'
      break
    case 'Tenant':
      label = 'Locataire'
      backgroundColor = 'green'
      break
  }

  return (
    <Chip
      key={role}
      label={label}
      style={{
        color: 'white',
        backgroundColor,
        margin: '.2em',
      }}
    />
  )
}
